export default "__VITE_PUBLIC_ASSET__a72eb632__"